import { render, staticRenderFns } from "./secao-05-unidade-ensino.vue?vue&type=template&id=1c620757"
import script from "./secao-05-unidade-ensino.vue?vue&type=script&lang=js"
export * from "./secao-05-unidade-ensino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports